

import { Button, Card, MenuItem, TextField } from '@mui/material'
import HeaderGestorConfigs from '../../../../../utils/headerGestorConfigs'
import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import api from '../../../../../services/api';
import LoadingShort from '../../../../../load/loadingShort';
import MessageError from '../../../../../messages/messageError';
import MessageSuccess from '../../../../../messages/messageSuccess';

export default function AddCategoriaProducto({ setProduto, produto }) {
    const user = useSelector(state => state.account.user);
    const dispatch = useDispatch()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [load, setLoad] = useState(false)
    // const [categorias, setCategorias] = useState('')
    const [categoria, setCategoria] = useState('')

    // useEffect(() => {
    //     api.get(`/get/categorias-disponivel}`)
    //         .then(response => {
    //             setCategorias(response.data);
    //         }).catch(err => { console.log(err) });
    // }, [produto])


    const handlecategoria = () => {
        setLoad(true)
        api.patch('/producto/edit-categoria', {
            // status: status,
            productoId: produto._id,
            categoria,
            userId: user?._id
        }).then(response => {
            setProduto(response.data.producto)
            dispatch({
                type: 'alert',
                payload: { alert: 'Categoria atribuida com sucesso.!' },
            });
            // console.log(response)
        }).catch(error => {
            setMessageError(error.response.data.message)
        }).finally(() => setLoad(false))
    }

    return (

        <Card style={{ padding: 20 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}
            <HeaderGestorConfigs
                menu={false}
                configArea={''}
                title={'ATRIBUIÇÃO DE CATEGORIA'}
            />

            <br />
            <TextField
                style={{ marginTop: 15 }}
                type="text"
                select
                required
                label="Atribuir categoria"
                fullWidth
                size="small"
                name="categoria"
                variant="outlined"
                onChange={(e) => setCategoria(e.target.value)}
                defaultValue={produto?.categoria}
            >
                {produto?.tipo === "Não Controlados" &&
                    <MenuItem value="Geral">Geral</MenuItem>
                }
                {produto?.tipo === "Controlados" &&
                    <MenuItem value="Especial">Especial</MenuItem>
                }
                {produto?.tipo === "Controlados" &&
                    <MenuItem value="Estupafaciente">Estupafaciente</MenuItem>
                }
                {produto?.tipo === "Controlados" &&
                    <MenuItem value="Percursores">Percursores</MenuItem>
                }
                {produto?.tipo === "Controlados" &&
                    <MenuItem value="Psicotrópico">Psicotrópico</MenuItem>
                }
            </TextField>

            <Button
                disabled={load || !categoria}
                // size="small"
                // color="warning" 
                // variant="outlined"
                onClick={handlecategoria}
            >
                {load ? <LoadingShort /> : "Salvar"}
            </Button>
        </Card>


        // <Loading text={'Acarregar produto..'} />
    )
}
